import { TRACKING_EVENT_NAMES, fireBookingPageShared } from 'hooks/analytics_events'
import { getEventTypeLocation } from 'hooks/useEventTypeLocation'

export const trackShareEvent = ({ track, eventTypeId, contactUuid, isRescheduleRequest, contactSource, isTemplateEdited }) => {
  track({
    name: TRACKING_EVENT_NAMES.SEND_VIA_CALENDLY,
    properties: {
      event_type_id: eventTypeId?.toString(),
      contact_uuid: contactUuid,
      contact_source: contactSource,
      is_reschedule_request: isRescheduleRequest,
      is_template_edited: isTemplateEdited,
      step: 'send_email'
    }
  })
}

export const trackFlowStarted = ({ track, kind, eventTypeId }) => {
  track({
    name: TRACKING_EVENT_NAMES.FLOW_STARTED,
    properties: {
      flow_name: 'send_from_calendly',
      flow_location: kind,
      flow_version: 'v1',
      event_type_id: eventTypeId
    }
  })
}

export const trackBookPageShared = ({ track, eventType, isReschedule, kind, features, customizedDetails = [], isAiNotetakerEnabled }) => {
  fireBookingPageShared(track, {
    share_location: kind,
    share_method: 'send_from_calendly',
    share_object_id: eventType?.id?.toString(),
    send_from_calendly_features: features,
    customized_details: customizedDetails,
    share_object: 'event_type',
    is_reschedule_link: isReschedule,
    is_customized_at_share: false,
    is_single_use: false,
    ...(eventType && {
      event_type_name: eventType.name,
      location_type: getEventTypeLocation(eventType) || null
    })
  }, isAiNotetakerEnabled)
}

export const buildFeaturesForTracking = (values, initialFormValues) => {
  const features = []
  if (values.sendWith.type !== 'calendly') {
    features.push('personal_email')
  }
  if (values.cc?.length > 0) {
    features.push('cc')
  }
  if (values.bcc?.length > 0) {
    features.push('bcc')
  }
  if (values.subject !== initialFormValues.subject) {
    features.push('custom_subject')
  }
  if (values.isReminderActive) {
    switch (values.remindInDays) {
      case 1:
        features.push('nudge_1day')
        break
      case 3:
        features.push('nudge_3day')
        break
      default:
        features.push('nudge_1week')
        break
    }
  }
  return features
}

export const trackCRMShareAvailEvent = ({ track, source }) => {
  let flowLocation = 'contacts_page_right_rail_header'
  if (source === 'CRM_CONTACT_CARD') {
    flowLocation = 'contact_hover_card'
  } else if (source === 'CRM_CONTACT_PAGE') {
    flowLocation = 'contact_details_page_header'
  }

  return track({
    name: TRACKING_EVENT_NAMES.FLOW_STEP_COMPLETED,
    properties: {
      flow_name: 'share_availability',
      flow_location: flowLocation,
      completion_method: 'step_completed',
      flow_step: 'select_et',
      flow_version: 'v1'
    }
  })
}

export const trackToggleRichTextEditorToolbar = ({ track, isShown, eventTypeId, contactIdentifier, source }) => {
  track({
    name: TRACKING_EVENT_NAMES.SEND_VIA_CALENDLY,
    properties: {
      event_type_id: eventTypeId?.toString(),
      contact_uuid: contactIdentifier,
      contact_source: source?.toLowerCase(),
      step: isShown ? 'hide_text_editor' : 'show_text_editor'
    }
  })
}

export const trackContactCardEvent = ({ track, eventType, contactUuid, isAiNotetakerEnabled }) => {
  track({
    name: TRACKING_EVENT_NAMES.SEND_VIA_CALENDLY,
    properties: {
      contact_source: 'contact_hover_card',
      contact_uuid: contactUuid,
      step: eventType ? 'share_availability' : 'send_email',
      event_type_id: eventType?.id?.toString()
    }
  })

  fireBookingPageShared(track, {
    share_location: 'contact_hover_card',
    share_method: 'send_from_calendly',
    share_object: 'event_type',
    is_single_use: false,
    ...(eventType && {
      share_object_id: eventType.id.toString(),
      event_type_name: eventType.name,
      location_type: getEventTypeLocation(eventType) || null
    })
  }, isAiNotetakerEnabled)
}

export const trackContactPageEvent = ({ track, eventType, contactUuid, isAiNotetakerEnabled }) => {
  track({
    name: TRACKING_EVENT_NAMES.SEND_VIA_CALENDLY,
    properties: {
      contact_source: 'contact_details_page_header',
      contact_uuid: contactUuid,
      step: eventType ? 'share_availability' : 'send_email',
      event_type_id: eventType?.id?.toString()
    }
  })

  fireBookingPageShared(track, {
    share_location: 'contact_details_page_header',
    share_method: 'send_from_calendly',
    share_object: 'event_type',
    is_single_use: false,
    ...(eventType && {
      share_object_id: eventType.id.toString(),
      event_type_name: eventType.name,
      location_type: getEventTypeLocation(eventType) || null
    })
  }, isAiNotetakerEnabled)
}
